import React, { useRef } from "react"

import classNames from "classnames"

import { toPixels } from "shared/lib/layoutUtils"
import { Draggable } from "shared/ui/draggable/Draggable"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useSwipeToDelete } from "./hooks/useSwipeToDelete"
import "./styles/_swipe-to-delete.scss"

export interface SwipeToDeleteProps {
  children: React.ReactNode
  onDelete?: () => void
  onDragStart?: () => void
  onDragEnd?: () => void
  deleteThreshold?: number
  dragThreshold?: number
  isDisabled?: boolean
  className?: string
  containerClassName?: string
}

export const SwipeToDelete = React.memo((props: SwipeToDeleteProps) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const { isDragging, isScrolling, xOffset, willDelete, ...rest } =
    useSwipeToDelete({
      ...props,
      contentRef
    })
  const { containerClassName, className, isDisabled, children } = props

  return (
    <div className={classNames(containerClassName, "swipe-to-delete")}>
      <Draggable
        ref={contentRef}
        isDisabled={isDisabled}
        {...rest}
        className={classNames(className, "swipe-to-delete__content", {
          animated: !isDragging,
          dragging: isDragging
        })}
        style={{
          marginLeft: toPixels(-xOffset),
          marginRight: toPixels(xOffset)
        }}
      >
        {children}
      </Draggable>
      <div className="swipe-to-delete__background-container">
        <div
          className={classNames("swipe-to-delete__background", {
            animated: !isDragging,
            "show-icon": xOffset > 30,
            "will-delete": willDelete
          })}
          style={{
            width: toPixels(xOffset)
          }}
        >
          <Icon name={IconName.BIN} />
        </div>
      </div>
    </div>
  )
})
